import React from 'react';
import ReactDOM from 'react-dom/client';

import './css/_third_party/bootstrap-5.0.2.css';
import App from './js/App';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
